import './style/index.less';
import RegisterTitle from './RegisterTitle';

export default RegisterTitle;
